import React, { useRef, useEffect, useCallback, useState} from 'react';
import {useScrollTo} from "components/selector2/useScrollTo.js"
import NewPackWindow from "components/packs/NewPackWindow.js";
import Colors from 'components/Colors.js';
import ipfs from 'decentralized/Ipfs.js';
import ethereum from "decentralized/ethereum.js";
import PackDetails from "components/packs/PackDetails.js";
import {connect} from 'react-redux';

const colors = new Colors();

const PackOption = ({pack, isSelected, scrollRef, sequencerEngine}) => { 
    let ref = useRef(undefined);
    let [userName, setUserName] = useState('');
    let [json, setJson] = useState(undefined);
    let [showing, setShowing] = useState(false);

    useScrollTo({scrollRef, ref, isCurrent: isSelected, topOffset: 100});

    useEffect(() => {
        ethereum.users.getUserName(pack.user).then(setUserName);
        ipfs.getJson(pack.packHash).then(setJson);
    }, []);

    let style = {
        backgroundColor: colors.getColorForHash(pack.title)
    };

    useEffect(() => {
        if (isSelected) {
            window.addEventListener("keydown", onKeyDown);
        } else {
            window.removeEventListener("keydown", onKeyDown);
        }
        return () => window.removeEventListener("keydown", onKeyDown);
    }, [setShowing, isSelected, showing]);

    const onKeyDown = useCallback((e) => {
        if (e.key === "Enter" && !showing && isSelected) {
            setShowing(true);
        }
    }, [isSelected, showing, setShowing]);

    useEffect(() => {
        if (pack.matchingContent) {
            setShowing(true);
        } else {
            setShowing(false);
        }
    }, [pack, setShowing]);

    if (showing) {
        return (
            <PackDetails
              sequencerEngine={sequencerEngine}
              scrollRef={scrollRef} style={style} pack={pack} json={json} userName={userName}/>
        );
    }
    return (
        <div ref={ref} style={style} onClick={() => setShowing(true)}
             className={isSelected ? "pack-option selected" : "pack-option"}>
          <div className="floppy-top">
            <div style={style} className="pack-title">{userName}</div>
          </div>
          <div className="floppy-sticker">
            <div className="pack-description">{pack.title}</div>
          </div>
        </div>
    );
}

const mapStateToProps = (state, props) => {
    let isSelected = state.packs.packSelected === props.pack;
    return {
        isSelected
    };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PackOption);
